import React from "react";
import { useSelector } from "react-redux";
import { WARRANTY_STEP } from "../../common/constant";
import { selectInfoWarranty } from "../../redux/reducers/slice/warranty";
import InformationProduct from "./infoProduct";
import "./registerWarrantyStyle.scss";

const RegisterWarranty = (props: any) => {
  const infoWarranty = useSelector(selectInfoWarranty);

  const handleRegister = () => {
    props.setStep(3);
  };

  const goToHome = () => {
    props.history.push("/");
  };

  return (
    <>
      <InformationProduct step={WARRANTY_STEP.REGISTER} />

      <div className="register-container">
        {infoWarranty?.allow_active_warranty ? (
          <div className="register-btn">
            <div className="register__home">
              <a onClick={goToHome}>Về trang chủ</a>
            </div>

            <div className="register__button" onClick={handleRegister}>
              <div className="btn">
                <p className="btn__text sub-title">Đăng ký</p>
                <p className="btn__text sub-content">
                  Thông tin bảo hành điện tử
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="register__button center" onClick={goToHome}>
            <div className="btn">
              <p className="btn__text sub-title">Về trang chủ</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default RegisterWarranty;
